export default {
	'custom-search-minus': {
		width: 415.49,
		height: 415.49,
		/* eslint-disable max-len */
		raw: '<rect x="76.5" y="153" width="172.125" height="19.125"/> <path d="M411.188,392.062L286.875,267.75l-1.912,1.912c24.862-28.688,40.162-66.937,40.162-107.1C325.125,72.675,252.45,0,162.562,0S0,72.675,0,162.562s72.675,162.562,162.562,162.562c42.075,0,78.412-15.3,107.1-40.162l-1.912,1.912l124.312,124.312c5.737,5.737,13.388,5.737,19.125,0S416.925,397.8,411.188,392.062z M162.562,306C84.15,306,19.125,240.975,19.125,162.562c0-78.413,65.025-143.438,143.438-143.438C240.975,19.125,306,84.15,306,162.562C306,240.975,240.975,306,162.562,306z"/>'
	}
};
